import { render, staticRenderFns } from "./WcFormsInvalidFeedbacks.vue?vue&type=template&id=d6045996&lang=pug&"
import script from "./WcFormsInvalidFeedbacks.vue?vue&type=script&lang=js&"
export * from "./WcFormsInvalidFeedbacks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports